module.exports = __webpack_public_path__ + "static/apple-touch-icon-2e3b141541538c27419d74a3acb76b8a.png";